import { useEffect, useState } from "react";
import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis, Tooltip, Cell } from "recharts";
import { api, gbp, fmtDate } from "@/lib/api";

const COLORS = { subscription: "#E5332A", report: "#0A0A0A", sponsorship: "#0A0A0A", tip: "#E5332A" };

const Stat = ({ label, value, testid }) => (
  <div className="bg-white border border-[#E7E7E7] p-6" data-testid={testid}>
    <p className="overline text-[#575757] !text-[9px]">{label}</p>
    <p className="font-display text-3xl font-bold mt-2">{value}</p>
  </div>
);

export const AdminOverview = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <p className="overline text-[#575757]">Loading…</p>;
  const chart = ["subscription", "sponsorship", "report", "tip"].map((k) => ({ name: k, value: s.revenue_by_kind[k] || 0 }));
  const subs = s.subscribers.pro + s.subscribers.institutional;

  return (
    <div className="space-y-8" data-testid="admin-overview">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat label="Total revenue" value={gbp(s.revenue_total, 2)} testid="stat-revenue" />
        <Stat label="Paying subscribers" value={`${subs}`} testid="stat-subscribers" />
        <Stat label="Sponsor leads" value={s.leads} testid="stat-leads" />
        <Stat label="Newsletter list" value={s.newsletter} testid="stat-newsletter" />
      </div>
      <div className="grid lg:grid-cols-12 gap-6">
        <div className="lg:col-span-7 bg-white border border-[#E7E7E7] p-6">
          <p className="font-display text-xl font-bold">Revenue by stream</p>
          <div className="h-64 mt-4">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={chart}>
                <XAxis dataKey="name" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} />
                <Tooltip formatter={(v) => gbp(v, 2)} />
                <Bar dataKey="value">{chart.map((c) => <Cell key={c.name} fill={COLORS[c.name]} />)}</Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="lg:col-span-5 bg-white border border-[#E7E7E7] p-6">
          <p className="font-display text-xl font-bold">Readership</p>
          <div className="mt-4 space-y-3 text-sm">
            {Object.entries(s.subscribers).map(([k, v]) => <div key={k} className="flex justify-between border-b border-[#E7E7E7] pb-2 capitalize"><span>{k}</span><span className="font-mono-d">{v}</span></div>)}
            <div className="flex justify-between pb-2"><span>Sponsorship inquiries</span><span className="font-mono-d">{s.inquiries}</span></div>
          </div>
          <p className="font-display text-lg font-bold mt-6">Most-read</p>
          {s.top_articles.map((a) => <p key={a.slug} className="text-sm mt-2 flex justify-between gap-3"><span className="truncate">{a.title}</span><span className="font-mono-d text-[#575757]">{a.views}</span></p>)}
        </div>
      </div>
      <div className="bg-white border border-[#E7E7E7] p-6">
        <p className="font-display text-xl font-bold">Recent transactions</p>
        <table className="w-full text-sm mt-4" data-testid="admin-transactions-table">
          <tbody>{s.recent_transactions.map((t) => (
            <tr key={t.session_id} className="border-t border-[#E7E7E7]">
              <td className="py-2">{fmtDate(t.created_at)}</td><td>{t.email || "guest"}</td><td className="capitalize">{t.lookup_key.replace(/_/g, " ")}</td>
              <td className="font-mono-d">{gbp(t.amount, 2)}</td><td>{t.payment_status}</td>
            </tr>))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
